import { forRails } from 'components/for-rails'
import { registerComponents } from '../src/utils/react/registry'
import { SkillSuggestionDialog } from 'components/skill-suggestion-dialog'

registerComponents({
  SkillSuggestionDialog: forRails(SkillSuggestionDialog),
})
